// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum CustomerRefundPaymentType {
  Transfer = "TRANSFER",
  PayGate = "PAY_GATE",
}
export default CustomerRefundPaymentType;
